import { axiosMock } from '@api/client';
import { API_URL } from '@api/apiDictionary';

export const fetchSponsorsMock = async () => {
  const data = [{ id: '1', name: 'Sponsor1' }, { id: '2', name: 'Sponsor2' }];
  return axiosMock.onGet(API_URL.sponsors).reply(200, data);
};

export const fetchTherapeuticAreasMock = async () => {
  const data = [{ name: 'TherapeuticArea1' }, { name: 'TherapeuticArea2' }];
  return axiosMock.onGet(API_URL.therapeutic).reply(200, data);
};

export const fetchPhasesMock = async () => {
  const data = [{ name: 'Phase1' }, { name: 'Phase2' }];
  return axiosMock.onGet(API_URL.phases).reply(200, data);
};

export const fetchDiseasesMock = async () => {
  const data = [{ name: 'Diseases1' }, { name: 'Diseases2' }];
  return axiosMock.onGet(API_URL.diseases).reply(200, data);
};
export const fetchLocationsMock = async () => {
  const data = [{ name: 'Location1' }, { name: 'Location2' }];
  return axiosMock.onGet(API_URL.locations).reply(200, data);
};
